























import {Vue, Component, Prop} from 'vue-property-decorator';
import Status from "@/domainObjects/Status";
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import TicketService from "@/services/TicketService";
import WipTicket from "@/domainObjects/wip/WipTicket";
import SearchHold from "@/domainObjects/hold/SearchHold";

@Component({
})

export default class StatusPicker extends Vue {
    @Prop({required: false}) data!: HoldTicket | WipTicket;
    @Prop({required: false}) selectMultiple!: boolean;
    @Prop({required: false}) search!: SearchHold;
    @Prop({required:false}) disabled!: boolean;
    @Prop({required: true}) type!: string;

    private statuses:Status[] = [];
    private selectedStatus = {} as Status;

    created() {
        if (this.type === 'hold') {
            TicketService.getHoldStatuses().then((response) => {
                for( let status of response.data ) {
                    let mappedStatuses:Status = {id: status.id, desc: status.desc, value: status.id, text: status.desc };
                    this.statuses.push(mappedStatuses);
                }
                if (this.data && this.data.status && this.data.status.id) {
                    let i = this.statuses.findIndex(status => status.value === this.data.status.id);
                    this.selectedStatus = this.statuses[i]
                }
            }).catch((error)=>{

            });
        }
        if (this.type === 'wip') {
            TicketService.getWipStatuses().then((response) => {
                for( let status of response.data ) {
                    let mappedStatuses:Status = {id: status.id, desc: status.desc, value: status.id, text: status.desc };
                    this.statuses.push(mappedStatuses);
                    this.selectedStatus = this.statuses[0];
                }
                if (this.data && this.data.status && this.data.status.id){
                    let i = this.statuses.findIndex(status => status.value === this.data.status.id);
                    this.selectedStatus = this.statuses[i];
                }
            }).catch((error)=>{

            });
        }
    }
    selectStatus(event){
        let value = this.statuses.filter(status => status.id == event.target.value);
        this.$emit('selectStatus', value[0])
    }
}
